// Chakra modal and popover are using zIndex 10 - don't exceed it
// eslint-disable-next-line @typescript-eslint/naming-convention
export const zIndex = {
  Negative: -1,
  Navbar: 5,
  TenderDetailInfoLine: 4,
  CookieConsentBanner: 6,
}
